const topicList = () => import('@/pages/community/topic/index.vue');

export default [{
    path: '/community/topic',
    component: topicList,
    meta: [{
        name: '社区管理'
    },
    {
        name: '话题列表',
        activeRoute: '/community/topic'
    }]
}];